module.exports = __webpack_public_path__ + "static/media/accessdenied.434b2dcb.jpg";